import { createSelector } from '@ngrx/store';
import { selectIsLoadingBestBetterDeals } from '@shared/store/best-better-deals/best-better-deals.selectors';
import { selectIsLoadingCompany } from '@shared/store/company/company.selectors';
import { selectIsLoadingMortgageCases } from '@shared/store/mortgage-cases/mortgage-cases.selectors';
import { selectIsLoadingMortgages } from '@shared/store/mortgages/mortgages.selectors';
import { selectIsLoadingProperties } from '@shared/store/properties/properties.selectors';
import { selectIsLoadingPortfolioSmartSearch } from './portfolio-smart-search.selector';

export const selectIsLoadingPortfolio = createSelector(
  selectIsLoadingMortgageCases,
  selectIsLoadingMortgages,
  selectIsLoadingProperties,
  selectIsLoadingBestBetterDeals,
  selectIsLoadingPortfolioSmartSearch,
  selectIsLoadingCompany,
  (
    isLoadingMortgageCases,
    isLoadingMortgages,
    isLoadingProperties,
    isLoadingBestBetterDeals,
    isLoadingPortfolioSmartSearch,
    isLoadingCompany,
  ) =>
    isLoadingMortgages ||
    isLoadingProperties ||
    isLoadingBestBetterDeals ||
    isLoadingMortgageCases ||
    isLoadingPortfolioSmartSearch ||
    isLoadingCompany,
);
